// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4127":"css/app.6862","4911":"css/admin-app.6862"}[chunkId] + ".css";
};